import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "tippy.js/dist/tippy.css";
import "./grids.css";
import { useTranslation } from "react-i18next";
import GridsModal from "./GridsModal";

function Grids(props) {
  const { t } = useTranslation(["translation"]);
  const [showGridsModal, setShowGridsModal] = useState(false);

  const handleGridSelect = (eventKey) => {
    props.toggleOptionsPanel();

    var isSelect = props.checkForSeletedItems();
    var rType = props.checkSelectedObjectType();
    var isMix = rType.isMix;
    var isSame = rType.isSame;

    if (!eventKey && !isSelect) {
      alert(t("grids-addItem"));
      return;
    } else if (!isSelect) {
      alert(t("grids-selectItem"));
      return;
    } else if (eventKey && !isSelect) {
      alert(t("grids-selectItem"));
      return;
    } else if (!isSame && isMix) {
      alert(t("grids-selectSameItem"));
      props.toggleOptionsPanel();
      return;
    }

    props.handleOptionsPanel(eventKey);
    document.body.style.overflow = "auto";
  };

  const handleButtonClick = () => {
    var isSelect = props.checkForSeletedItems();
    var rType = props.checkSelectedObjectType();
    var isMix = rType.isMix;
    var isSame = rType.isSame;

    if (!isSelect) {
      alert(t("grids-selectItem"));
      return;
    } else if (!isSame && isMix) {
      alert(t("grids-selectSameItem"));
      return;
    }

    setShowGridsModal(!showGridsModal);
  };

  return (
    <div className="d-inline dropup">
      {/* Options Button - Toggles Grids Modal */}
      <button
        className="btn mt-1 btn-block pb-0 m-0 btn-primary btn-sm"
        onClick={handleButtonClick}
      >
        <img
          className="optionsButton"
          src="/icons/optionsButton.png"
          height="40px"
          alt="Options"
          title={t("grids-options")}
        />
      </button>
      
      {/* Grids Modal */}

      {/* Grids Modal */}
      <GridsModal
        show={showGridsModal}
        onHide={() => setShowGridsModal(false)}
        onGridSelect={handleGridSelect}
        windowURL={props.windowURL}
        isSelectedItem={props.isSelectedItem}
        typeName={props.typeName}
        addOption={props.addOption}
        addTransum={props.addTransum}
        setGlassToSearch={props.setGlassToSearch}
        setStringToSearch={props.setStringToSearch}
        setStringToSearchSide={props.setStringToSearchSide}
        isTransum={props.isTransum}
        setIsTransum={props.setIsTransum}
        title={t("grids-options", "Options")}
      />
    </div>
  );
}
export default Grids;
